
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PlanCard extends Vue {
    @Prop() name!: string;
    @Prop() price!: number;
    @Prop() interval!: string;
}
